module.exports = __webpack_public_path__ + "static/media/bus-eireann.c901c7eb.png";